import { useTranslation } from 'react-i18next'
import { FeatureCollection } from '@turf/turf'
import { LoadingButton } from '@mui/lab'
import { Card, CardActions, CardContent, Fade, Stack, Typography } from '@mui/material'
import { FieldCardErrors } from './FieldCardErrors'
import { fieldSizeValidation } from '../../'

interface FieldEditorCardProps {
  features: FeatureCollection
  loading?: boolean
  onSave: (features: FeatureCollection) => void
  touched: boolean
}

/**
 * WIP component; likely to let the user edit more details from here
 */
export const FieldEditorCard = ({ features, loading, touched, onSave }: FieldEditorCardProps) => {
  const { t } = useTranslation('FieldEditorCard')
  const { acres, errorMessages } = fieldSizeValidation(features)

  return (
    <Fade in={touched || errorMessages.length > 0}>
      <Stack spacing={2}>
        {errorMessages.length > 0 && <FieldCardErrors messages={errorMessages} />}
        <Card>
          <CardContent>
            <Typography>{t('acreage', { count: acres })}</Typography>
          </CardContent>
          <CardActions>
            <LoadingButton
              loading={loading}
              variant="contained"
              onClick={() => onSave(features)}
              disabled={!touched || errorMessages.length > 0}
              fullWidth
            >
              {t('save')}
            </LoadingButton>
          </CardActions>
        </Card>
      </Stack>
    </Fade>
  )
}
